/**
*
* TenantForm14163
*
*/

import { TenantForm } from 'pages/Requests/TenantView';
import { SERVICE } from 'domain/Data/RequestType/constants';

class TenantForm14163 extends TenantForm { // eslint-disable-line react/prefer-stateless-function
  getFields() {
    const fields = super.getFields();

    const assigneeIndex = fields.findIndex((field) => field.name === 'assignee');
    fields[assigneeIndex].calculatedValue = (values, mode, entities) => {
      let assignee = null;
      if (values.type === SERVICE && values.service && entities) {
        entities.get('services').forEach((item) => {
          if (values.service === item.id) assignee = item.manager;
        });
      }
      return assignee;
    };

    return fields;
  }
}

export default TenantForm14163;
